// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Services
import Billing from 'services/data/billing';

// Actions
import { alerts } from 'modules/alerts/actions';

// Components
import { SVGButton } from 'components/widgets/buttons/buttons';
import FormPopover from 'components/widgets/overlays/form';
import BillingForm from 'components/models/agreement/billing-form';
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';


// Component
export default class EditBillingPopup extends React.Component {
  static propTypes = {
    billing: PropTypes.object,
    eagerUpdate: PropTypes.func,
    afterSubmit: PropTypes.func
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const { eagerUpdate, afterSubmit } = this.props;

    if (eagerUpdate) eagerUpdate(values);
    this.editForm.toggle();

    return Billing.update(values)
      .then(billing => {
        if (afterSubmit) afterSubmit(billing);
      })
      .catch(alerts.catchError);
  }

  render() {
    const { billing } = this.props;
    const initialValues = _.pick(billing, ['id', 'amount', 'description', 'releaseDate']);

    return (
      <div className="add-person">
        { !billing.invoice &&
          <FormPopover
            target={<SVGButton src="svg/edit.svg" className="edit-button edit-link" />}
            title="Edit Billing"
            ref={(el) => { this.editForm = el; }}
          >
            <div>
              <div className="form-header">
                <SVG src="svg/billing.svg" className="billing" />
                <h5 className="form-title">Edit Billing</h5>
                <SVG onClick={() => this.editForm.toggle()} className="close" src="svg/close.svg" />
              </div>
              <BillingForm
                onSubmit={this.onSubmit}
                form={`edit-billing-popup-${billing.id}`}
                initialValues={initialValues}
              />
            </div>
          </FormPopover>
        }

        { billing.invoice &&
          <Tooltip title="This billing has been invoiced and can't be edited">
            <SVG src="svg/edit.svg" className="svg-only-button deemphasized-button disabled" />
          </Tooltip>
        }
      </div>
    );
  }
}
